import { UnitLease } from '@/models/features'

export const DAY_MS = 24 * 60 * 60 * 1000
const AVERAGE_MONTH_DAYS = 30.44

export const getLeaseDaysLeft = (lease?: UnitLease | null, now = Date.now()) =>
  lease?.leaseStatus === 'Current' && lease.leaseEnd && lease.leaseEnd > now
    ? Math.ceil((lease.leaseEnd - now) / DAY_MS)
    : null

export const getLeaseTermMonths = (lease?: UnitLease | null) =>
  lease?.leaseStart && lease.leaseEnd
    ? Math.round((lease.leaseEnd - lease.leaseStart) / (AVERAGE_MONTH_DAYS * DAY_MS))
    : null
